// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/accessconflict/v1/accessviolation.proto" (package "c1.api.accessconflict.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Facets } from "../../search/v1/facet";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { Any } from "../../../../google/protobuf/any";
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AccessViolationExpandMask
 */
export interface AccessViolationExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AccessViolationAuditExpandMask
 */
export interface AccessViolationAuditExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AccessViolationListRequest
 */
export interface AccessViolationListRequest {
    /**
     * @generated from protobuf field: string conflict_monitor_id = 1;
     */
    conflictMonitorId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.AccessViolationExpandMask expand_mask = 4;
     */
    expandMask?: AccessViolationExpandMask;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AccessViolationView
 */
export interface AccessViolationView {
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.AccessViolation access_violation = 1;
     */
    accessViolation?: AccessViolation;
    /**
     * @generated from protobuf field: string identity_user_path = 2;
     */
    identityUserPath: string;
    /**
     * @generated from protobuf field: string group_a_app_path = 3;
     */
    groupAAppPath: string;
    /**
     * @generated from protobuf field: string group_a_app_entitlement_path = 4;
     */
    groupAAppEntitlementPath: string;
    /**
     * @generated from protobuf field: string group_b_app_path = 5;
     */
    groupBAppPath: string;
    /**
     * @generated from protobuf field: string group_b_app_entitlement_path = 6;
     */
    groupBAppEntitlementPath: string;
    /**
     * @generated from protobuf field: string group_a_app_user_path = 7;
     */
    groupAAppUserPath: string;
    /**
     * @generated from protobuf field: string group_b_app_user_path = 8;
     */
    groupBAppUserPath: string;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AccessViolationListResponse
 */
export interface AccessViolationListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessconflict.v1.AccessViolationView list = 1;
     */
    list: AccessViolationView[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AccessViolationUpdateStatusRequest
 */
export interface AccessViolationUpdateStatusRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string conflict_monitor_id = 2;
     */
    conflictMonitorId: string;
    /**
     * @generated from protobuf field: string reason = 3;
     */
    reason: string;
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.AccessViolationExpandMask expand_mask = 4;
     */
    expandMask?: AccessViolationExpandMask;
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.Status status = 5;
     */
    status: Status;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AccessViolationUpdateStatusResponse
 */
export interface AccessViolationUpdateStatusResponse {
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.AccessViolationView view = 1;
     */
    view?: AccessViolationView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AccessViolation
 */
export interface AccessViolation {
    /**
     * @generated from protobuf field: string id = 2;
     */
    id: string;
    /**
     * @generated from protobuf field: string conflict_monitor_id = 3;
     */
    conflictMonitorId: string;
    /**
     * @generated from protobuf field: string identity_user_id = 4;
     */
    identityUserId: string;
    /**
     * @generated from protobuf field: string group_a_app_id = 5;
     */
    groupAAppId: string;
    /**
     * @generated from protobuf field: string group_a_app_entitlement_id = 6;
     */
    groupAAppEntitlementId: string;
    /**
     * @generated from protobuf field: string group_b_app_id = 7;
     */
    groupBAppId: string;
    /**
     * @generated from protobuf field: string group_b_app_entitlement_id = 8;
     */
    groupBAppEntitlementId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 9;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 10;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 11;
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.Status status = 12;
     */
    status: Status;
    /**
     * @generated from protobuf field: string group_a_app_user_id = 13;
     */
    groupAAppUserId: string;
    /**
     * @generated from protobuf field: string group_b_app_user_id = 14;
     */
    groupBAppUserId: string;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AccessViolationAudit
 */
export interface AccessViolationAudit {
    /**
     * @generated from protobuf field: string id = 2;
     */
    id: string;
    /**
     * @generated from protobuf field: string conflict_monitor_id = 3;
     */
    conflictMonitorId: string;
    /**
     * @generated from protobuf field: string access_violation_id = 4;
     */
    accessViolationId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 6;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 7;
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf oneof: typ
     */
    typ: {
        oneofKind: "created";
        /**
         * @generated from protobuf field: c1.api.accessconflict.v1.ViolationAuditCreated created = 100;
         */
        created: ViolationAuditCreated;
    } | {
        oneofKind: "exempted";
        /**
         * @generated from protobuf field: c1.api.accessconflict.v1.ViolationAuditExempted exempted = 101;
         */
        exempted: ViolationAuditExempted;
    } | {
        oneofKind: "exemptionRemoved";
        /**
         * @generated from protobuf field: c1.api.accessconflict.v1.ViolationAuditExemptionRemoved exemption_removed = 102;
         */
        exemptionRemoved: ViolationAuditExemptionRemoved;
    } | {
        oneofKind: "resolved";
        /**
         * @generated from protobuf field: c1.api.accessconflict.v1.ViolationAuditResolved resolved = 103;
         */
        resolved: ViolationAuditResolved;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AccessViolationAuditView
 */
export interface AccessViolationAuditView {
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.AccessViolationAudit access_violation_audit = 1;
     */
    accessViolationAudit?: AccessViolationAudit;
    /**
     * @generated from protobuf field: string identity_user_path = 2;
     */
    identityUserPath: string;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ViolationAuditCreated
 */
export interface ViolationAuditCreated {
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ViolationAuditExempted
 */
export interface ViolationAuditExempted {
    /**
     * @generated from protobuf field: string reason = 1;
     */
    reason: string;
    /**
     * @generated from protobuf field: string updated_by = 2;
     */
    updatedBy: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3;
     */
    updatedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ViolationAuditExemptionRemoved
 */
export interface ViolationAuditExemptionRemoved {
    /**
     * @generated from protobuf field: string reason = 1;
     */
    reason: string;
    /**
     * @generated from protobuf field: string updated_by = 2;
     */
    updatedBy: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3;
     */
    updatedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ViolationAuditResolved
 */
export interface ViolationAuditResolved {
    /**
     * @generated from protobuf field: string reason = 1;
     */
    reason: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3;
     */
    updatedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AccessViolationAuditListRequest
 */
export interface AccessViolationAuditListRequest {
    /**
     * @generated from protobuf field: string conflict_monitor_id = 1;
     */
    conflictMonitorId: string;
    /**
     * @generated from protobuf field: string access_violation_id = 2;
     */
    accessViolationId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.AccessViolationAuditExpandMask expand_mask = 5;
     */
    expandMask?: AccessViolationAuditExpandMask;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AccessViolationAuditListResponse
 */
export interface AccessViolationAuditListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessconflict.v1.AccessViolationAuditView list = 1;
     */
    list: AccessViolationAuditView[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AccessViolationRef
 */
export interface AccessViolationRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string conflict_monitor_id = 2;
     */
    conflictMonitorId: string;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AccessViolationCountRefreshRef
 */
export interface AccessViolationCountRefreshRef {
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AccessViolationSearchRequest
 */
export interface AccessViolationSearchRequest {
    /**
     * @generated from protobuf field: string conflict_monitor_id = 1;
     */
    conflictMonitorId: string;
    /**
     * @generated from protobuf field: repeated c1.api.accessconflict.v1.Status access_violation_status = 2;
     */
    accessViolationStatus: Status[];
    /**
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string app_entitlement_ids = 4;
     */
    appEntitlementIds: string[];
    /**
     * @generated from protobuf field: repeated string identity_user_ids = 5;
     */
    identityUserIds: string[];
    /**
     * @generated from protobuf field: repeated c1.api.accessconflict.v1.AccessViolationRef refs = 6;
     */
    refs: AccessViolationRef[];
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.AccessViolationExpandMask expand_mask = 7;
     */
    expandMask?: AccessViolationExpandMask;
    /**
     * @generated from protobuf field: int32 page_size = 8;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 9;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AccessViolationSearchResponse
 */
export interface AccessViolationSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessconflict.v1.AccessViolationView list = 1;
     */
    list: AccessViolationView[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AccessViolationGetSearchTermsRequest
 */
export interface AccessViolationGetSearchTermsRequest {
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.AccessViolationSearchRequest search = 1;
     */
    search?: AccessViolationSearchRequest;
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.AccessViolationGetSearchTermsRequest.TermType term = 2;
     */
    term: AccessViolationGetSearchTermsRequest_TermType;
    /**
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * @generated from protobuf field: bool include_count = 4;
     */
    includeCount: boolean;
}
/**
 * @generated from protobuf enum c1.api.accessconflict.v1.AccessViolationGetSearchTermsRequest.TermType
 */
export enum AccessViolationGetSearchTermsRequest_TermType {
    /**
     * @generated from protobuf enum value: UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: APP_ENTITLEMENT_IDS = 1;
     */
    APP_ENTITLEMENT_IDS = 1,
    /**
     * @generated from protobuf enum value: IDENTITY_USER_IDS = 2;
     */
    IDENTITY_USER_IDS = 2
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AccessViolationGetSearchTermsResponse
 */
export interface AccessViolationGetSearchTermsResponse {
    /**
     * @generated from protobuf field: c1.api.search.v1.Facets facets = 1;
     */
    facets?: Facets;
}
/**
 * @generated from protobuf enum c1.api.accessconflict.v1.Status
 */
export enum Status {
    /**
     * @generated from protobuf enum value: STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: STATUS_ACTIVE = 1;
     */
    ACTIVE = 1,
    /**
     * @generated from protobuf enum value: STATUS_EXEMPTED = 2;
     */
    EXEMPTED = 2,
    /**
     * @generated from protobuf enum value: STATUS_RESOLVED = 3;
     */
    RESOLVED = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class AccessViolationExpandMask$Type extends MessageType<AccessViolationExpandMask> {
    constructor() {
        super("c1.api.accessconflict.v1.AccessViolationExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "identity_user_id", "group_a_app_id", "group_a_app_entitlement_id", "group_b_app_id", "group_b_app_entitlement_id", "group_a_app_user_id", "group_b_app_user_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AccessViolationExpandMask
 */
export const AccessViolationExpandMask = new AccessViolationExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessViolationAuditExpandMask$Type extends MessageType<AccessViolationAuditExpandMask> {
    constructor() {
        super("c1.api.accessconflict.v1.AccessViolationAuditExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "identity_user_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AccessViolationAuditExpandMask
 */
export const AccessViolationAuditExpandMask = new AccessViolationAuditExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessViolationListRequest$Type extends MessageType<AccessViolationListRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.AccessViolationListRequest", [
            { no: 1, name: "conflict_monitor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AccessViolationExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AccessViolationListRequest
 */
export const AccessViolationListRequest = new AccessViolationListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessViolationView$Type extends MessageType<AccessViolationView> {
    constructor() {
        super("c1.api.accessconflict.v1.AccessViolationView", [
            { no: 1, name: "access_violation", kind: "message", T: () => AccessViolation },
            { no: 2, name: "identity_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "group_a_app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "group_a_app_entitlement_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "group_b_app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "group_b_app_entitlement_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "group_a_app_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "group_b_app_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AccessViolationView
 */
export const AccessViolationView = new AccessViolationView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessViolationListResponse$Type extends MessageType<AccessViolationListResponse> {
    constructor() {
        super("c1.api.accessconflict.v1.AccessViolationListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessViolationView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AccessViolationListResponse
 */
export const AccessViolationListResponse = new AccessViolationListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessViolationUpdateStatusRequest$Type extends MessageType<AccessViolationUpdateStatusRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.AccessViolationUpdateStatusRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "conflict_monitor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "expand_mask", kind: "message", T: () => AccessViolationExpandMask },
            { no: 5, name: "status", kind: "enum", T: () => ["c1.api.accessconflict.v1.Status", Status, "STATUS_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AccessViolationUpdateStatusRequest
 */
export const AccessViolationUpdateStatusRequest = new AccessViolationUpdateStatusRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessViolationUpdateStatusResponse$Type extends MessageType<AccessViolationUpdateStatusResponse> {
    constructor() {
        super("c1.api.accessconflict.v1.AccessViolationUpdateStatusResponse", [
            { no: 1, name: "view", kind: "message", T: () => AccessViolationView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AccessViolationUpdateStatusResponse
 */
export const AccessViolationUpdateStatusResponse = new AccessViolationUpdateStatusResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessViolation$Type extends MessageType<AccessViolation> {
    constructor() {
        super("c1.api.accessconflict.v1.AccessViolation", [
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "conflict_monitor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "identity_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "group_a_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 6, name: "group_a_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 7, name: "group_b_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 8, name: "group_b_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 9, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 10, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 11, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 12, name: "status", kind: "enum", T: () => ["c1.api.accessconflict.v1.Status", Status, "STATUS_"] },
            { no: 13, name: "group_a_app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 14, name: "group_b_app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AccessViolation
 */
export const AccessViolation = new AccessViolation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessViolationAudit$Type extends MessageType<AccessViolationAudit> {
    constructor() {
        super("c1.api.accessconflict.v1.AccessViolationAudit", [
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "conflict_monitor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "access_violation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 100, name: "created", kind: "message", oneof: "typ", T: () => ViolationAuditCreated },
            { no: 101, name: "exempted", kind: "message", oneof: "typ", T: () => ViolationAuditExempted },
            { no: 102, name: "exemption_removed", kind: "message", oneof: "typ", T: () => ViolationAuditExemptionRemoved },
            { no: 103, name: "resolved", kind: "message", oneof: "typ", T: () => ViolationAuditResolved }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AccessViolationAudit
 */
export const AccessViolationAudit = new AccessViolationAudit$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessViolationAuditView$Type extends MessageType<AccessViolationAuditView> {
    constructor() {
        super("c1.api.accessconflict.v1.AccessViolationAuditView", [
            { no: 1, name: "access_violation_audit", kind: "message", T: () => AccessViolationAudit },
            { no: 2, name: "identity_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AccessViolationAuditView
 */
export const AccessViolationAuditView = new AccessViolationAuditView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ViolationAuditCreated$Type extends MessageType<ViolationAuditCreated> {
    constructor() {
        super("c1.api.accessconflict.v1.ViolationAuditCreated", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ViolationAuditCreated
 */
export const ViolationAuditCreated = new ViolationAuditCreated$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ViolationAuditExempted$Type extends MessageType<ViolationAuditExempted> {
    constructor() {
        super("c1.api.accessconflict.v1.ViolationAuditExempted", [
            { no: 1, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "updated_by", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ViolationAuditExempted
 */
export const ViolationAuditExempted = new ViolationAuditExempted$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ViolationAuditExemptionRemoved$Type extends MessageType<ViolationAuditExemptionRemoved> {
    constructor() {
        super("c1.api.accessconflict.v1.ViolationAuditExemptionRemoved", [
            { no: 1, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "updated_by", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ViolationAuditExemptionRemoved
 */
export const ViolationAuditExemptionRemoved = new ViolationAuditExemptionRemoved$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ViolationAuditResolved$Type extends MessageType<ViolationAuditResolved> {
    constructor() {
        super("c1.api.accessconflict.v1.ViolationAuditResolved", [
            { no: 1, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ViolationAuditResolved
 */
export const ViolationAuditResolved = new ViolationAuditResolved$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessViolationAuditListRequest$Type extends MessageType<AccessViolationAuditListRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.AccessViolationAuditListRequest", [
            { no: 1, name: "conflict_monitor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "access_violation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AccessViolationAuditExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AccessViolationAuditListRequest
 */
export const AccessViolationAuditListRequest = new AccessViolationAuditListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessViolationAuditListResponse$Type extends MessageType<AccessViolationAuditListResponse> {
    constructor() {
        super("c1.api.accessconflict.v1.AccessViolationAuditListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessViolationAuditView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AccessViolationAuditListResponse
 */
export const AccessViolationAuditListResponse = new AccessViolationAuditListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessViolationRef$Type extends MessageType<AccessViolationRef> {
    constructor() {
        super("c1.api.accessconflict.v1.AccessViolationRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "conflict_monitor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AccessViolationRef
 */
export const AccessViolationRef = new AccessViolationRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessViolationCountRefreshRef$Type extends MessageType<AccessViolationCountRefreshRef> {
    constructor() {
        super("c1.api.accessconflict.v1.AccessViolationCountRefreshRef", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AccessViolationCountRefreshRef
 */
export const AccessViolationCountRefreshRef = new AccessViolationCountRefreshRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessViolationSearchRequest$Type extends MessageType<AccessViolationSearchRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.AccessViolationSearchRequest", [
            { no: 1, name: "conflict_monitor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "access_violation_status", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.accessconflict.v1.Status", Status, "STATUS_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_entitlement_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "identity_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessViolationRef },
            { no: 7, name: "expand_mask", kind: "message", T: () => AccessViolationExpandMask },
            { no: 8, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 9, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AccessViolationSearchRequest
 */
export const AccessViolationSearchRequest = new AccessViolationSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessViolationSearchResponse$Type extends MessageType<AccessViolationSearchResponse> {
    constructor() {
        super("c1.api.accessconflict.v1.AccessViolationSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessViolationView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AccessViolationSearchResponse
 */
export const AccessViolationSearchResponse = new AccessViolationSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessViolationGetSearchTermsRequest$Type extends MessageType<AccessViolationGetSearchTermsRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.AccessViolationGetSearchTermsRequest", [
            { no: 1, name: "search", kind: "message", T: () => AccessViolationSearchRequest },
            { no: 2, name: "term", kind: "enum", T: () => ["c1.api.accessconflict.v1.AccessViolationGetSearchTermsRequest.TermType", AccessViolationGetSearchTermsRequest_TermType] },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "include_count", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AccessViolationGetSearchTermsRequest
 */
export const AccessViolationGetSearchTermsRequest = new AccessViolationGetSearchTermsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessViolationGetSearchTermsResponse$Type extends MessageType<AccessViolationGetSearchTermsResponse> {
    constructor() {
        super("c1.api.accessconflict.v1.AccessViolationGetSearchTermsResponse", [
            { no: 1, name: "facets", kind: "message", T: () => Facets }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AccessViolationGetSearchTermsResponse
 */
export const AccessViolationGetSearchTermsResponse = new AccessViolationGetSearchTermsResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.accessconflict.v1.AccessViolationService
 */
export const AccessViolationService = new ServiceType("c1.api.accessconflict.v1.AccessViolationService", [
    { name: "ListAccessViolation", options: { "authz.method": { role: "VIEWER" } }, I: AccessViolationListRequest, O: AccessViolationListResponse },
    { name: "UpdateAccessViolationStatus", options: { "authz.method": { role: "EDITOR" } }, I: AccessViolationUpdateStatusRequest, O: AccessViolationUpdateStatusResponse },
    { name: "ListAccessViolationAudit", options: { "authz.method": { role: "VIEWER" } }, I: AccessViolationAuditListRequest, O: AccessViolationAuditListResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.accessconflict.v1.AccessViolationSearch
 */
export const AccessViolationSearch = new ServiceType("c1.api.accessconflict.v1.AccessViolationSearch", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: AccessViolationSearchRequest, O: AccessViolationSearchResponse },
    { name: "GetSearchTerms", options: { "authz.method": { role: "VIEWER" } }, I: AccessViolationGetSearchTermsRequest, O: AccessViolationGetSearchTermsResponse }
]);
